import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useReleaseAssortmentIAFlag } from '../flags/useReleaseAssortmentIAFlag';

export const Route = createFileRoute('/$')({
  component: NotFoundRedirect,
});

function NotFoundRedirect() {
  const releaseAssortmentIA = useReleaseAssortmentIAFlag();
  const navigate = useNavigate();

  useEffect(() => {
    if (releaseAssortmentIA) {
      navigate({ to: '/new', replace: true });
    } else {
      navigate({ to: '/in-season', replace: true });
    }
  }, [releaseAssortmentIA, navigate]);

  return null;
}
